import React, { useEffect, useState } from 'react';
import DoughnutGauge from '../../dashboard/components/DoughnutGauge';
import BarChart from '../../../common/components/charts/BarChart';

import { useGetCultureHubAnalyticsQuery } from '@/areas/culture-hub/api/cultureHubApi';
import LoadingSpinner from '@/common/components/LoadingSpinner';
import { BodyText, PageSection } from '@/common/styles/page';
import { Title } from '@/common/styles/page';
import TeamPillarBarChart from './TeamPillarBarChart';

interface TeamPillarScoresProps {
  assessment_period_id: number;
  teamId: number;
}

const TeamPillarScores: React.FC<TeamPillarScoresProps> = ({
  assessment_period_id,
  teamId,
}) => {
  const [pillarScores, setPillarScores] = useState<{ label: string; value: number }[]>([]);
  const [overallScore, setOverallScore] = useState<number>(0);

  const { data: analyticsData, isLoading, isSuccess, isFetching } = useGetCultureHubAnalyticsQuery(
    { assessmentPeriodId: assessment_period_id!, teamId },
    { skip: !assessment_period_id }
  );

  console.log('team id in TeamPillarScores:', teamId);


  useEffect(() => {
    if (!analyticsData) return;

    // Ensure analytics belongs to requested team when team_id is present
    if (typeof analyticsData.team_id !== 'undefined' && analyticsData.team_id !== teamId) return;

    const pillarScoreData = Array.isArray(analyticsData.pillar_scores?.pillars)
      ? analyticsData.pillar_scores.pillars
      : [];

    const overall = analyticsData.pillar_scores?.overall_score ?? 0;

    const scores = pillarScoreData.map((item: { label: string; average_response: number }) => ({
      label: item.label,
      value: Number.isFinite(item.average_response) ? parseFloat(item.average_response.toFixed(1)) : 0,
    }));

    setPillarScores(scores);
    setOverallScore(overall);
  }, [analyticsData, teamId, assessment_period_id]);

  if (isLoading || isFetching) {
    return (
      <LoadingSpinner />
    );
  }

  if (!isSuccess || pillarScores.length === 0) {
    return (
      <PageSection>
        <Title padbottom="10px">Team Culture Pillars</Title>
        <BodyText>No data is available for this team.</BodyText>
      </PageSection>
    );
  }

  return (
    <PageSection display='flex' flexDirection='column' width='100%' padbottom='10px'>
      <Title padbottom="10px">Team Culture Pillars</Title>

      <PageSection display='flex' width='100%'>
        <DoughnutGauge title={'Overall Score'} max={10} complete={overallScore} precision={1} />
        <TeamPillarBarChart data={pillarScores} multiple={10} percent={false} />
      </PageSection>
    </PageSection>
  );
};

export default TeamPillarScores;
